export default "__VITE_ASSET__b4f5969b__"